import React from "react";
import Cards from "../UI/Cards";
import styles from "./WorkMenu.module.css";

const WorkMenu = () => {
  return (
    <div className={styles.workCtn} id="work">
      <div className={styles.titleCtn}>
        <h2 className={styles.workTitle}>Work</h2>
        <h3 className={styles.workDesc}>A few of my clients.</h3>
      </div>
      <div className={styles.workItemCtn}>
        <Cards
          title="Freelance work"
          desc="Landing page developed with HTML and CSS for client. Just desktop"
          img="https://res.cloudinary.com/dcegpqqjc/image/upload/v1677015560/Screenshot_2023-02-21_at_18.36.30_na6s15.png"
          website="https://listingok.netlify.app/"
        />
      </div>
      <div className={styles.workItemCtn}>
        <Cards
          title="Roswell"
          desc="One example of the various ecommerces done with React or Vue and Liquid"
          img="https://res.cloudinary.com/dcegpqqjc/image/upload/v1675608849/Screenshot_2023-02-05_at_11.54.11_qyyrcn.png"
          website="https://www.juliska.com/"
        />
      </div>
      <div className={styles.workItemCtn}>
        <Cards
          title="Advancing Diversity"
          desc="Developed admin's dashboard and integrated Calendly for scheduling meetings. Stack React, .NET and MSSQL"
          img="https://res.cloudinary.com/dcegpqqjc/image/upload/v1675608681/Screenshot_2023-02-05_at_11.46.39_xmzv39.png"
          website="https://advancingdiversity.netlify.app/"
        />
      </div>
      <div className={styles.workItemCtn}>
        <Cards
          title="Eton Auction"
          desc="Designed Front end for Eton Auction e-commerce. Website developed with NextJs."
          img="https://res.cloudinary.com/dcegpqqjc/image/upload/v1659638566/Screen_Shot_2022-08-04_at_15.41.45_taw4za.png"
          website="https://etonauctionecommerce.vercel.app/"
        />
      </div>
      <div className={styles.workItemCtn}>
        <Cards
          title="Suca"
          desc="Portfolio made for a cinema director. Made entirely with React JS. Desktop only."
          img="https://res.cloudinary.com/dfjpoucxs/image/upload/v1637505239/Suca/Screen_Shot_2021-11-21_at_11.33.49_nf67w5.png"
          website="https://sucaproject.netlify.app/"
        />
      </div>
    </div>
  );
};

export default WorkMenu;
